import config from '../config';
import { post, get as requestGet } from '.';

const UNAUTHORIZED_CODE = 401;
export const HEADERS = {
  CLIENT_ID: 'X-AA-Client-Id',
  API_KEY: 'X-Api-Key',
  GA_CLIENT_ID: 'x-ga-client-id',
  ACCEPT_VERSION: 'Accept-version',
  AUTHORIZATION: 'Authorization',
};

export const ROUTES = {
  BY_ORIGIN: 'config/v2/clients/by-origin',
  NAVITAIRE: 'um/v2/user-navitaire-info',
  REFRESH_TOKEN: '/auth/v2/authorization/by-refresh-token',
};

let clientId = '';
let apiKey = '';
const baseUrl = config.REACT_APP_SSO_BASE_URL;

const requestByOrigin = async () => {
  const route = ROUTES.BY_ORIGIN;
  // For mobile we need to set Origin header
  // for web it's going to be appended by the browser and this won't take effect
  const headers = { Origin: config.REACT_APP_SSO_ORIGIN };
  const { body } = await requestGet(route, { baseUrl, headers });

  clientId = body.id;
  apiKey = body.apiKey;
  return {
    clientId,
    apiKey,
  };
};

const refreshSSOToken = async (apiKey, clientId, token) => {
  const route = ROUTES.REFRESH_TOKEN;
  const headers = {
    'x-api-key': apiKey,
    'x-aa-client-id': clientId,
    'Content-Type': 'application/json',
  };
  const params = {
    refreshToken: token,
  };
  const { body } = await post(route, { baseUrl, params, headers });
  return body?.accessToken;
};

const MAX_RETRIES = 5;
let tries = 0;

const get = async (route, config = {}) => {
  const { headers = {} } = config;
  headers[HEADERS.CLIENT_ID] = clientId;
  headers[HEADERS.API_KEY] = apiKey;
  const response = await requestGet(route, { ...config, baseUrl, headers });

  if (response.status !== UNAUTHORIZED_CODE || tries > MAX_RETRIES) {
    tries = 0;
    return response;
  }

  tries += 1;
  await requestByOrigin();
  return get(route, config);
};

export default { get, authorize: requestByOrigin, refreshSSOToken };
